import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_increase",
  "use": "icon-icon_increase-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-icon_increase\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h8v8H0z\" /><path d=\"M6.021 7.014H2.012c-.323 0-.617-.217-.757-.56a1.35 1.35 0 0 1 .124-1.24l2.004-2.86c.16-.216.39-.34.634-.34.243 0 .474.124.633.34l2.004 2.86c.24.352.287.832.124 1.24-.14.343-.434.56-.757.56Z\" fill=\"#ED4F4F\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol